import React, { useState } from "react";
import { useAppSelector } from "../../../context-store";
import InterviewerService from '../../../services/interviewer/interviewer-service';
import toasterUtils from "../../../utils/toaster-utils";
import dateUtils from "../../../utils/date-utils";
import InterviewerSchedulesModel from "../../../models/interviewer/response/InterviewerSchedulesModel";
import InterviewerSchedulesRequestModel from "../../../models/interviewer/request/InterviewerSchedulesRequestModel";
import modalUtils from "../../../utils/modal-utils";
import { DayofWeekEnum } from "../../../models/enums/DayofWeekEnum";
import loaderUtils from "../../../utils/loader-utils";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Button } from "@mui/material";

interface CloneScheduleProps {
    schedule: InterviewerSchedulesModel;
}

const CloneScheduleComponent = (props: CloneScheduleProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    let weekdays: string[] = [DayofWeekEnum.Monday.toString(), DayofWeekEnum.Tuesday.toString(), DayofWeekEnum.Wednesday.toString(), DayofWeekEnum.Thursday.toString(), DayofWeekEnum.Friday.toString()];
    let weekEnds: string[] = [DayofWeekEnum.Sunday.toString(), DayofWeekEnum.Saturday.toString()];
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());
    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
    const [dayOfWeek, setDayOfWeek] = useState<string>(dateUtils.getDayFromDate(props.schedule.date));
    const startDateHanler = (date: any) => {
        setStartDate(date);
    };

    const endDateHanler = (date: any) => {
        setEndDate(date);
    };

    const cloneSchedule = () => {
        if (loggedInUser && startDate && endDate) {
            var sDate = startDate.toDate();
            var eDate = endDate.toDate();
            var timslotsSaveList: InterviewerSchedulesRequestModel[] = [];
            while (sDate <= eDate) {
                let saveSchedule: boolean = true;
                if (weekdays.indexOf(dayOfWeek) > -1) {
                    if (dateUtils.getDayFromDateFormat(sDate) === DayofWeekEnum.Saturday.toString()) {
                        saveSchedule = false;
                    }
                    if (dateUtils.getDayFromDateFormat(sDate) === DayofWeekEnum.Sunday.toString()) {
                        saveSchedule = false;
                    }
                } else if (weekEnds.indexOf(dayOfWeek) > -1) {
                    if (weekdays.indexOf(dateUtils.getDayFromDateFormat(sDate)) > -1) {
                        saveSchedule = false;
                    }
                }

                if (saveSchedule) {
                    let objTimeSlot: InterviewerSchedulesRequestModel = {
                        interviewerId: loggedInUser.profileId,
                        startDate: dateUtils.getFormattedDate(sDate),
                        endDate: dateUtils.getFormattedDate(sDate),
                        timeSlotIds: props.schedule.timeSlotIds,
                        blockSchedule: false
                    }
                    timslotsSaveList.push(objTimeSlot);
                }
                sDate = dateUtils.addDays(sDate, 1);
            }
            if (timslotsSaveList.length > 0) {
                modalUtils.showLoader();
                InterviewerService.saveInterviewerSchedule(timslotsSaveList).then((res) => {
                    modalUtils.closeModal();
                    if (!res.isSuccess || res.errorMessages.length > 0) {
                        toasterUtils.showError(res.errorMessages.toString());
                        return;
                    }
                    toasterUtils.showSuccess(res.informationMessages.toString());
                    clearSchedule();
                }).catch((error) => {
                    modalUtils.closeModal();
                    toasterUtils.showError(error);
                });
            }
        }
    }

    const clearSchedule = () => {
        setStartDate(null);
        setEndDate(null);
        modalUtils.closeModal();
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="From"
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                            format="YYYY-MMM-DD"
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    size: "small",
                                },
                            }}
                        />
                    </LocalizationProvider>
                </div>
                <div className="col-md-4">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="To"
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            format="YYYY-MMM-DD"
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    size: "small",
                                },
                            }}
                        />
                    </LocalizationProvider>
                </div>
                {weekdays.indexOf(dayOfWeek) > -1 &&
                    <div className="col-md-4">
                        <Button variant="contained" color="success" onClick={() => cloneSchedule()} disabled={startDate === null || endDate === null}>
                            Clone for all weekdays
                        </Button>
                    </div>
                }
                {weekEnds.indexOf(dayOfWeek) > -1 &&
                    <div className="col-md-4">
                        <Button variant="contained" color="success" onClick={() => cloneSchedule()} disabled={startDate === null || endDate === null}>
                            Clone for all weekends
                        </Button>
                    </div>
                }
            </div>
            <div className="row">
                <div className="col-md-8"></div>
                <div className="col-md-4">
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={clearSchedule}>
                        Clear
                    </Button>
                </div>
            </div>
        </div >
    );
};
export default CloneScheduleComponent;